export default [
    {
        path: '/auth/reset_password/:token',
        component: () => import(/* webpackChunkName: "main" */ '@/components/auth/reset-password'),
        name: 'ResetPassword'
    },
    {
        path: '/auth/register',
        component: () => import(/* webpackChunkName: "main" */ '@/components/auth/Register'),
        name: 'Register'
    },
    {
        path: '/auth/error',
        component: () => import(/* webpackChunkName: "main" */ '@/components/auth/Error'),
        name: 'Error'
    }
];
